@if (isGameNotesVisible) {
    <ms-game-notes class="game-notes-layout" [gameNotes]="gameNotes" />
}
<ms-event-info
    [event]="event"
    [showEventTimerInfoSection]="showEventTimerInfoSection"
    [showFixedFooterSection]="showFixedFooterSection"
    [mediaEnabled]="mediaEnabled"
    [disableBadges]="!!promotedFixtureIdsMap[event.id] && isMobilePhone"
    [showPlayerStatisticsButton]="showPlayerStatisticsButton()">
    @if (promotedFixtureIdsMap[event.id]) {
        <ms-promotion-badge />
    }
</ms-event-info>

<div class="grid-event-info all-markets-link">
    <span class="title">{{ sitecore.eventGrid.AllMarketsLink | msInterpolate: { count: event.totalMarketsCount } }}</span>
    <ng-container *msShowInEpcot="false">
        <span class="icon-alignment"><vn-icon name="theme-right" size="11" /></span>
    </ng-container>
    @if (gridConfig.gridEventDisplayVersion === 'V2') {
        <span class="icon-alignment"><vn-icon name="theme-right" size="12" /></span>
    }
</div>
